import React, { forwardRef } from 'react';
import { SvgIconProps, useTheme } from '@mui/material';
import { ReactComponent as VideoIcon } from './Icons/videoIcon.svg';

interface DSVideoIconProps extends SvgIconProps {
  component?: React.ElementType;
}

const DSVideoIcon = forwardRef<SVGSVGElement, DSVideoIconProps>(
  (props, ref) => {
    const { spacing } = useTheme();

    return (
      <VideoIcon
        ref={ref}
        {...props}
        style={{ height: spacing(3), width: spacing(3), ...props.style }}
      />
    );
  },
);

DSVideoIcon.displayName = 'DSVideoIcon';

export default DSVideoIcon;
